import { FaHtml5,FaReact,FaLaravel,FaGithub,FaDocker } from "react-icons/fa";
import { BiLogoFlutter,BiLogoDjango } from "react-icons/bi";



const SKILLS_DATA = [
  {
    category: "Frontend",
    items: [
        {
            title : "HTML+CSS+JS",
            icon : <FaHtml5/>
        },
        {
            title : "React",
            icon : <FaReact/>
        },
        {
            title : "Flutter",
            icon : <BiLogoFlutter/>
        },
    ]
  },
  {
    category: "Backend",
    items: [
        {
            title : "Laravel",
            icon : <FaLaravel/>
        },
        {
            title : "Django",
            icon : <BiLogoDjango/>
        },
    ]
  },
  {
    category: "Other",
    items: [
        {
            title : "git",
            icon : <FaGithub/>
        },
        {
            title : "Docker",
            icon : <FaDocker/>
        },
    ]
  },];

export default SKILLS_DATA;